/** Integrations and webhooks. */
export default [

  {
    path: '/integrations',
    name: 'Integrations',
    component: () => import('@/views/private/integration/IntegrationsView.vue'),
    meta: {
      public: false,
      title: 'Integrations',
    },
  },

  {
    path: '/integrations/:integrationId',
    name: 'Integration',
    component: () => import('@/views/private/integration/IntegrationView.vue'),
    props: function(route) {
      return {
        integrationId: Number(route.params.integrationId),
      };
    },
    meta: {
      public: false,
      title: 'Integration',
    },
  },

  {
    path: '/webhooks',
    name: 'Webhooks',
    component: () => import('@/views/private/integration/WebhooksView.vue'),
    meta: {
      public: false,
      title: 'Webhooks',
    },
  },

  {
    path: '/webhooks/:webhookId',
    name: 'Webhook',
    component: () => import('@/views/private/integration/WebhookView.vue'),
    props: function(route) {
      return {
        webhookId: Number(route.params.webhookId),
      };
    },
    meta: {
      public: false,
      title: 'Webhook',
    },
  },

];
